import React from 'react';
import {Link} from 'react-router-dom';
import './Breadcrumbs.sass';

interface Props {
  currentPage: string;
  parentLink: string;
  parentLabel: string;
}

function Breadcrumbs({parentLink, currentPage, parentLabel}: Props) {
  return (
    <nav className="uikit-breadcrumbs">
      {parentLabel && (
        <Link to={parentLink} className="uikit-breadcrumbs__item">
          {parentLabel}
        </Link>)}
      {currentPage && (
        <span className="uikit-breadcrumbs__item">
          {currentPage}
        </span>
      )}
    </nav>
  );
}

export default Breadcrumbs;
